import React from "react";
import { Card, Table, Badge } from "react-bootstrap";
import useSWR from "swr";
import { serverUrl, fetcher, swrConfig } from "../../../../helpers/utility";
import Loading from "../../../../components/loading";
import { format } from "date-fns";

function TeamMembersList({ user }) {
  const { data, error, isLoading } = useSWR(
    `${serverUrl}/provider/team-members`,
    fetcher,
    swrConfig
  );

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
      <Card>
        <Card.Body>
          <p className="text-danger">Error loading team members. Please try again.</p>
        </Card.Body>
      </Card>
    );
  }

  const members = data?.users || [];

  const getRoleBadge = (role) => {
    if (role === "super_admin") {
      return <Badge bg="primary">Super Admin</Badge>;
    }
    if (role === "admin") {
      return <Badge bg="secondary">Admin</Badge>;
    }
    return <Badge bg="light" text="dark">User</Badge>;
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Team Members ({members.length})</h5>
      </Card.Header>
      <Card.Body>
        {members.length === 0 ? (
          <p className="text-muted">No team members yet.</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member._id}>
                  <td>
                    {member.firstname || member.lastname
                      ? `${member.firstname || ""} ${member.lastname || ""}`.trim()
                      : "—"}
                  </td>
                  <td>{member.email}</td>
                  <td>{getRoleBadge(member.role)}</td>
                  <td>
                    {member.created
                      ? format(new Date(member.created), "dd/MM/yyyy")
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default TeamMembersList;

